<template>
  <div  style="width: 440px">
    <div :id="id" :style="{ width: '100%', height: '500px' }"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: "pie-statistics-modular",
  data () {
    return {}
  },
  props: {
    title: {
      type: String
    },
    id: {
      type: String,
    },
    data: {
      type: Array,
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  mounted () {
    this.drawLine();
  },
  methods: {
    drawLine () {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById(this.id))
      // 绘制图表
      myChart.setOption({

        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          top: '5%',
          left: 'center',
          // textStyle:{
          //   'color':'#fff'
          // }
        },
        series: [
          {
            name: '数量统计',
            type: 'pie',
            radius: '50%',
            // label: {
            //   formatter: '{b}：{c} ({d}%)'
            // },
            data: this.data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      });
    }
  },
  watch: {
    data () {
      this.drawLine();
    }
  }
}
</script>

<style scoped lang="scss">
.title-warpper {
  display: flex;
  align-items: center;
  height: 60px;
  font-size: 16px;

  .title-text {
    color: #667fa0;

    i {
      font-size: 20px;
      margin-right: 10px;
    }
  }
  .wecome {
    font-size: 16px;
    font-weight: 500;
    color: #666666;
    span {
      color: #0d7fd7;
    }
  }
}
</style>